export const WAIT_TIME_SEC_RESEND_INVITE = 30;
